import createDeepSelector from './create_deep_selector'
import _ from 'lodash'

const getTours = (state, { useManagedCustomer = false } = {}) => {
  if (useManagedCustomer) {
    return state.managedCustomerData.tours || state.tours
  } else {
    return state.tours
  }
}
const getAddAll = (state, { addAll = false } = {}) => addAll
const getAddEmptyOption = (state, { addEmptyOption = true } = {}) => addEmptyOption

const getToursOptions = createDeepSelector(
  [ getTours, getAddAll, getAddEmptyOption ],
  (toursById, addAll, addEmptyOption) => {
    let tours = _.values(toursById)
    tours = _.sortBy(tours, tour => tour.name)
    if (addAll) {
      tours.push({
        id: 'all',
        name: window.I18n.t('customer_center_menu.selectors.all'),
      })
    }
    if (addEmptyOption) {
      tours.push({
        id: 'none',
        name: window.I18n.t('customer_center_menu.selectors.no_tour'),
      })
    }
    return tours
  },
)

export default getToursOptions
